import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../utlis/Breadcrumb";

const s3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

function Provisional() {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Breadcrumb */}
      <div className="InnerSld">
        <Breadcrumb
          img={`${s3_url}/CSSK/public/Images/page-title.jpg`}
          title="Provisional"
          title2="Message"
          path="Provisional Message"
        />
      </div>

      {/* Manager Message Section */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="message-div">
            {/* Manager Image */}
            <div className="messageimg">
              <img
                id="manager-image"
                className="img-fluid lazyload"
                src={`${s3_url}/CSSK/public/Images/Provincial.jpg`}
                alt="Provisional's Image"
              />

              {/* Social Media Overlay */}
              <div className="social-overlay">
                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="bi bi-facebook"></i>
                </a>

                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <i className="bi bi-twitter-x"></i>
                </a>

                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="bi bi-instagram"></i>
                </a>

                <a
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
              </div>
            </div>

            {/* Manager Message */}
            <div id="managermessage">
              Anything in life worth having is worth working for. Socrates says,
              "True education is not inserting the stuff of information into a
              person, but rather eliciting knowledge from him, it is drawing out
              of what is in mind". School is a place where the God given talents
              in the students are recognized, nurtured, and led to flourish and
              fructify. Academic excellence along with co-curricular and extra
              co-curricular activities completes the process of education. And
              it gives me great satisfaction that the school is progressing in
              all its endeavours towards the overall development and personality
              of the students. Apart from preparing the children to quality for
              purely academic demands, special efforts are being made
              continuously to enable them to face the challenges of the
              competitive world. Schools play a major role in preparing children
              for their future lives. Good education and good health go
              hand-in-hand in giving children a better start in life. From its
              very beginning in 1998 the Carmel School has been imparting value
              based, quality education. The school aims at turning out students
              who strive for excellence in all fields and at the same time hold
              on to the traditional moral and ethical values.In today's society
              where money and muscle power far outweight an other values of
              life, this school stands as a beacon to society, manifesting by
              what it stands for and inculcates in its students that spiritual
              and ethical values are the true guides that will lead a person to
              happiness and a meaningful life. With the blessings of the
              Almighty, the School may continue to grow in all ways in the years
              to come.
            </div>

            {/* Manager Name & Designation */}
            <p id="manager-name">
              <strong>
                Warmest Regards,
                <br />
                Sr. Beena Therese
                <br />
                Provincial Superior,Carmel School Sarangabad
              </strong>
            </p>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Provisional;
